<mat-drawer-container class="!flex !flex-col !min-h-screen" autosize>
  <mat-drawer
    position="end"
    mode="over"
    [opened]="cartService.isOpen()"
    (closed)="cartService.setCartOpen(false)"
    class="!max-w-md !w-full"
  >
    <app-cart />
  </mat-drawer>

  <mat-drawer-content class="!flex !flex-col">
    <app-header ngSkipHydration />
    <main class="flex-1">
      <router-outlet />
    </main>
    <app-footer />
    <app-whatsapp-button />
  </mat-drawer-content>
</mat-drawer-container>
